export enum AxiosInstances {
    Normal = 'normal',
    Mongo = 'mongo'
}
